/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("basicInformationRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.basicinformation",{
        url:"/basicinformation?userType",
        views:{
            "main@register": {
                templateUrl: "./login/register/basicInformation/basicInformation_tpl.html",
                controller: "basicInformationCtrl"
            }
        }
    });
}]);